// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ItemPrices-itemPrice__gboGk{color:var(--gray-12);font:var(--font-heading-h1);font-feature-settings:var(--feature-settings-heading-h1);letter-spacing:var(--letter-spacing-heading-h1)}.ItemPrices-priceComparison__oNCsD{display:flex;flex-wrap:wrap;gap:var(--size-2) var(--size-8)}.ItemPrices-priceEntry__UZOrE{display:flex;flex-direction:column;gap:var(--size-1)}.ItemPrices-priceLabel__dV9uu{color:var(--gray-a11);font:var(--font-caption-medium-400);font-feature-settings:var(--feature-settings-caption-medium-400);letter-spacing:var(--letter-spacing-caption-medium-400)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"itemPrice": "ItemPrices-itemPrice__gboGk",
	"priceComparison": "ItemPrices-priceComparison__oNCsD",
	"priceEntry": "ItemPrices-priceEntry__UZOrE",
	"priceLabel": "ItemPrices-priceLabel__dV9uu"
};
export default ___CSS_LOADER_EXPORT___;
